"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const fi_1 = require("react-icons/fi");
require("./SignalementAdmin.css");
const AddSignalementModal_1 = __importDefault(require("./Modals/AddSignalementModal"));
const SignalementsTable_1 = __importDefault(require("./Tables/SignalementsTable"));
const SignalementAdmin = () => {
    const [addSignalement, setAddSignalement] = (0, react_1.useState)(false);
    const handleAddSignalementModal = () => setAddSignalement(true);
    return (react_1.default.createElement("div", { className: "dashbord-admin-component" },
        react_1.default.createElement("div", { className: "dash-admin-page-content-container mb-3" },
            react_1.default.createElement("div", { className: "container-fluid" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-lg-12" },
                        react_1.default.createElement("div", { className: "sub-title-page-admin pb-3" }, "Signalements"),
                        react_1.default.createElement("div", { className: "row mt-5" },
                            react_1.default.createElement("div", { className: "col-lg-12 sunu-autoroute-admin-titre-page-container mb-3" },
                                react_1.default.createElement("div", { className: "admin-titre-page" }, "Signalements"),
                                react_1.default.createElement("div", { className: "sunu-autoroute-admin-btn-add-container" },
                                    react_1.default.createElement("button", { className: "sunu-autoroute-admin-btn-add", onClick: handleAddSignalementModal },
                                        react_1.default.createElement(fi_1.FiPlusSquare, null),
                                        " Ajouter un signalement"),
                                    react_1.default.createElement(AddSignalementModal_1.default, { addSignalement: addSignalement, setAddSignalement: setAddSignalement })))),
                        react_1.default.createElement("div", { className: "row" },
                            react_1.default.createElement(SignalementsTable_1.default, null))))))));
};
exports.default = SignalementAdmin;
